import axios from 'axios';
import get from 'lodash/get';

import { Consequence } from '../../libs/utils';

import {
  PACKAGE_STATS,
  SUBSCRIPTION_ACTIVE,
  RESET_FREEMIUM,
  RESET_COUNTERS,
  BACK_TO_FREE,
  REMOVE_PAYMENT_METHOD,
  USERS
} from '../../constants/endpoints';

export const NEW_INVOICES_QTY = 'NEW_INVOICES_QTY';
export const NEW_DOWNLOADS_QTY = 'NEW_DOWNLOADS_QTY';
export const NEW_XML_QTY = 'NEW_XML_QTY';
export const NEW_REMINDERS_QTY = 'NEW_REMINDERS_QTY';
export const NEW_PLAN = 'NEW_PLAN';
export const NEW_ROLE = 'NEW_ROLE';
export const NEW_PACKAGE_STATS = 'NEW_PACKAGE_STATS';
export const PURGE_PACKAGES = 'PURGE_PACKAGES';
export const NEW_USERS = 'NEW_USERS';

export function purgePackages() {
  return dispatch => {
    dispatch({ type: PURGE_PACKAGES, payload: 0 });
  };
}

export function getPackagesStats() {
  return async dispatch => {
    const response = await axios.get(PACKAGE_STATS);
    return new Consequence({
      payload: { data: get(response, 'data.data') },
      eventTypes: { success: NEW_PACKAGE_STATS, error: 'ERROR' },
      dispatch
    });
  };
}

export function givePackagesQty(qty) {
  return dispatch => {
    dispatch({ type: NEW_INVOICES_QTY, payload: qty || 50 });
    dispatch({ type: NEW_DOWNLOADS_QTY, payload: qty || 50 });
    dispatch({ type: NEW_XML_QTY, payload: qty || 50 });
    dispatch({ type: NEW_REMINDERS_QTY, payload: qty || 50 });
  };
}

export function updateInvoiceQuantity(qty) {
  return dispatch => {
    dispatch({ type: NEW_INVOICES_QTY, payload: qty });
  };
}

export function updateXmlQuantity(qty) {
  return dispatch => {
    dispatch({ type: NEW_XML_QTY, payload: qty });
  };
}

export function updatePlan(plan) {
  return dispatch => {
    dispatch({ type: NEW_PLAN, payload: plan });
  };
}

export function updateRole(role) {
  return dispatch => {
    dispatch({ type: NEW_ROLE, payload: role });
  };
}

export function getUsers() {
  return dispatch =>
    axios.get(USERS).then(res => {
      const allUsers = get(res, 'data.data');
      const admin = allUsers.filter(user => user.rol.id === 1);
      const users = allUsers.filter(user => user.rol.id === 2);
      const payloadUsers = { admin, users };
      return new Consequence({
        dispatch,
        payload: { data: payloadUsers },
        eventTypes: { success: NEW_USERS, error: 'ERROR' }
      });
    });
}

// Suscription
export function getSubscription() {
  return dispatch =>
    axios.get(SUBSCRIPTION_ACTIVE).then(res => {
      const plan = get(res, 'data.data.description');
      return new Consequence({ dispatch, payload: { data: plan }, eventTypes: { success: NEW_PLAN, error: 'ERROR' } });
    });
}

/*
La secuencia es la siguiente:
1.- Se debe cambiar el plan a free
    DELETE /v1/team/subscription
2.- Se eleimina el método de pago
   DELETE /v1/team/payment_method
3.- Opcionalmente puede cambiarse a freemium
   POST /v1/settings/freemium
*/
export function resetBackFreemium() {
  return dispatch =>
    axios
      .delete(BACK_TO_FREE)
      .then(() => axios.delete(REMOVE_PAYMENT_METHOD))
      .then(() => axios.post(RESET_FREEMIUM))
      .then(() => axios.get(SUBSCRIPTION_ACTIVE))
      .then(res => {
        const plan = get(res, 'data.data.description');
        return new Consequence({
          dispatch,
          payload: { data: plan },
          eventTypes: { success: NEW_PLAN, error: 'ERROR' }
        });
      });
}

export function resetBackCounters() {
  return dispatch =>
    axios
      .post(RESET_COUNTERS)
      .then(() => axios.get(PACKAGE_STATS))
      .then(
        res =>
          new Consequence({
            payload: { data: get(res, 'data.data') },
            eventTypes: { success: NEW_PACKAGE_STATS, error: 'ERROR' },
            dispatch
          })
      );
}



// WEBPACK FOOTER //
// ./src/redux/actions/permsActions.js